// extracted by mini-css-extract-plugin
export default {"card":"Permissions_card__0X9VD","card_dark":"Permissions_card_dark__r7F-8"};